<!--
 - Bcx page filters component HTML
 -
 - @version
 - 4.70.0 OAUI-678 Build "Driver Assignment" UI
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2024 Build Centrix
 -->
<div class="bcx-page-filters">
  <div class="row">
    <!-- Main Container -->
    <div class="col-md-6">
      <div class="main-container">
        <!-- Left Div -->
        <div class="left-container">
          <!--Navigation-->
          <div class="inner-content navigation">
            <ng-content select="[navigation]"></ng-content>
          </div>
          <!--Settings-->
          <div class="inner-content settings">
            <ng-content select="[settings]"></ng-content>
          </div>
          <!--Date Type-->
          <div class="inner-content">
            <ng-content select="[date-type]"></ng-content>
          </div>
          <!--Date Start-->
          <div class="inner-content">
            <ng-content select="[date-start]"></ng-content>
          </div>
          <!--Date End-->
          <div class="inner-content">
            <ng-content select="[date-end]"></ng-content>
          </div>
          <!--Select Action-->
          <div class="inner-content">
            <ng-content select="[select-action]"></ng-content>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Div -->
    <div class="col-md-6">
      <div class="main-container">
        <div class="right-container">
          <div class="inner-content">
            <ng-content select="[filter-1]"></ng-content>
          </div>
          <div class="inner-content">
            <ng-content select="[filter-2]"></ng-content>
          </div>
          <div class="inner-content">
            <ng-content select="[filter-3]"></ng-content>
          </div>
          <div class="inner-content">
            <ng-content select="[filter-4]"></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
